/**
 * Part of datavideo project.
 *
 * @copyright  Copyright (C) 2021 __ORGANIZATION__.
 * @license    __LICENSE__
 */

import ZoomCalc from '@/app/front/zoom-calc';

S.import('@main')
  .then(() => {
    new Vue({
      name: 'zoom-calc',
      el: 'zoom-calc',
      components: {
        ZoomCalc
      }
    });
  });

